<template>
    <div class="netteach-add">
        <div class="netteach-crumbs">
            <router-link to="/netteach">网络教研</router-link>
            <span><i>></i>发起评课</span>
        </div>
        <div class="netteach-add-content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="活动主题" prop="theme">
                    <el-input v-model="ruleForm.theme" placeholder="最多可以输入20个字符" maxlength="20"></el-input>
                </el-form-item>
                
                <el-form-item label="活动要求" prop="ask">
                    <el-input type="textarea" v-model="ruleForm.ask" :rows="4" placeholder="在此可输入活动要求(最多200字)" maxlength="200"></el-input>
                    <span class="word-number"><i>{{ruleForm.ask.length}}</i>/200</span>
                </el-form-item>

                <el-form-item label="评课视频" prop="video">
                    <el-button type="primary" @click="getVideoData()">选择</el-button>
                    <div class="tagList">
                        <el-tag :key="index" v-for="(tag, index) in videoList" closable :disable-transitions="false" @close="handleClose(index, 'video')">
                            {{tag.video_name}}
                        </el-tag>
                    </div>
                    <el-checkbox-group v-model="ruleForm.video" class='hide'>
                        <el-checkbox :label="item.id" name="type" :key="index" v-for="(item, index) in videoList" checked>{{item.video_name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="活动时间" required class="date-time">
                    <el-form-item prop="startTime">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.startTime" type="datetime" :picker-options='pickerOptions' placeholder="选择开始时间"></el-date-picker>
                    </el-form-item>
                    <i>至</i>
                    <el-form-item prop="endTime">
                        <el-date-picker v-model="ruleForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options='pickerOptions' placeholder="选择结束期时间"></el-date-picker>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="参与人" prop="participant">
                    <el-button type="primary" @click="participantShow()">选择</el-button>
                    <div class="tagList">
                        <el-tag :key="index" v-for="(tag, index) in participantList" closable :disable-transitions="false" @close="handleClose(index, 'participant')">
                            {{tag.name}}
                        </el-tag>
                    </div>
                    <el-checkbox-group v-model="ruleForm.participant" class='hide'>
                        <el-checkbox :label="item.id" name="type" :key="index" v-for="(item, index) in participantList" checked>{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="评估标准" prop="standard">
                    <el-button type="primary" @click="standardShow()">选择</el-button>
                    <router-link target="_blank"  to="/netteach/standard">评课标准管理</router-link>
                    <div class="tagList">
                        <el-tag :key="index" v-for="(tag, index) in standardList" closable :disable-transitions="false" @close="handleClose(index, 'standard')">
                            {{tag.name}}
                        </el-tag>
                    </div>
                    <el-checkbox-group v-model="ruleForm.standard" class='hide'>
                        <el-checkbox :label="item.id" name="type" :key="index" v-for="(item, index) in standardList" checked>{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="算分方式" prop="mode">
                    <el-radio-group v-model="ruleForm.mode">
                        <el-radio :label="0">全部相加法：全部相加平均数</el-radio>
                        <el-radio :label="1">去除首尾法：参与人大于等于5的时候，去掉最大值和最小值后，相加求平均数；小于5则全部相加求平均数</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="评分明细公开范围" prop="range" class="netteach-range">
                    <el-checkbox-group v-model="ruleForm.range">
                        <el-checkbox label="0" name="type">发起方</el-checkbox>
                        <el-checkbox label="1" name="type">主讲教师</el-checkbox>
                        <el-checkbox label="2" name="type">参与人</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="netteach-btn">
                    <el-button @click="resetForm('ruleForm')" type="primary" plain>取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog title="选择视频" top="5vh" :visible.sync="videoVisible" width="800px" :close-on-click-modal="false">
            <div class="video-keyword">
                <el-input placeholder="视频名" suffix-icon="el-icon-search" v-model="keyword" @change="getVideoData">
                </el-input>
            </div>
            <el-table :data="videoData" border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="selectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="video_name" label="视频名" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="category" label="视频分类" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="user_name" label="上传者" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="type_name" label="视频信息" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="操作" width="80px" align='center'>
                    <template slot-scope="scope">
                        <el-button class="video-preview" @click="preview(scope.row.rtmp_url)">预览</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="pageIndex" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSum">
            </el-pagination>
            <div class="video-btn">
                <el-button type="primary" plain  @click="videoVisible = false">取消</el-button>
                <el-button type="primary" @click="submitVideo()">确定</el-button>
            </div>
        </el-dialog>


        <transition name="el-fade-in-linear">
            <div  class="video-view" :class="{ videoView: isVideoView }">
                <div class="video-play">
                    <div class="video-view-t clear">
                        <span>视频预览</span>
                        <i class="el-icon-close" @click="closeVideo"></i>
                    </div>
                    <videoAlertView  v-if="showVideoPlayer" class="maxW train-video-player" :playParam.sync="playParam"></videoAlertView>
                    <!-- <video-player class="video-player vjs-custom-skin maxW train-video-player" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player> -->
                </div>
            </div>
        </transition>

        <el-dialog title="选择参与人" top="5vh" :visible.sync="participantVisible" width="800px" :close-on-click-modal="false">
            <div class="video-keyword">
                <el-select v-model="roleVal" placeholder="选择参与人角色" @change="getParticipant">
                    <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-input placeholder="用户名" suffix-icon="el-icon-search" v-model="keyword2" @change="getParticipant">
                </el-input>
            </div>
            <el-table :data="participantData" border style="width: 100%" ref="multipleTable2" tooltip-effect="dark" @selection-change="participantChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="number" label="登录帐号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" label="用户名" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="role_name" label="角色" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="sex_name" label="性别" show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChange2" @current-change="currentChange2" :current-page="pageIndex2" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSize2" layout="total, sizes, prev, pager, next, jumper" :total="totalSum2">
            </el-pagination>
            <div class="video-btn">
                <el-button type="primary" plain @click="participantVisible = false">取消</el-button>
                <el-button type="primary" @click="submitParticipant()">确定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="选择评估标准" top="5vh" :visible.sync="standardVisible" width="800px" :close-on-click-modal="false">
            <div class="video-keyword">
                <el-select v-model="subject" placeholder="请选择科目" @change="getStandard">
                    <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-input placeholder="用户名" suffix-icon="el-icon-search" v-model="keyword3" @change="getStandard">
                </el-input>
            </div>
            <el-table :data="standardData" border style="width: 100%"    @current-change="handleCurrentChange" @row-click="showStandardradio">
                <el-table-column type="index" width="55">
                    <template slot-scope="scope">
                        <el-radio class="radio" v-model="standardradio" :label="scope.$index">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="标准名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="user_name" label="撰写者" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="subject_name" label="科目名" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="total_score" label="总分" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="use_count" label="使用次数" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="操作" width="80px" align='center'>
                    <template slot-scope="scope">
                        <el-button class="video-preview" @click="viewCriteriaShow(scope.row.id)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChange3" @current-change="currentChange3" :current-page="pageIndex3" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSize3" layout="total, sizes, prev, pager, next, jumper" :total="totalSum3">
            </el-pagination>
            <div class="video-btn">
                <el-button type="primary" plain @click="standardVisible = false">取消</el-button>
                <el-button type="primary" @click="submitStandard()">确定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="查看评分标准" :visible.sync="viewCriteria" width="800px" :close-on-click-modal="false">
            <div class="substandard-title">
                <span>撰写人: {{viewCriteriaList.user_name}}</span>
                <span>分数: {{viewCriteriaList.total_score}}</span>
            </div>
            <template>
                <table class="standard-item">
                    <tr>
                        <th>项目</th>
                        <th>评价内容</th>
                        <th>分数</th>
                    </tr>
                    <template v-for="(item, index) of viewCriteriaList.standard_item">
                        <template v-if="item.child.length === 0">
                            <tr>
                                <td>{{item.name}}</td>
                                <td>--</td>
                                <td>{{item.score}}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(child, index2) of item.child">
                                <td :rowspan="item.child.length" v-if="index2 === 0">{{item.name}}</td>
                                <td>{{child.name}}</td>
                                <td>{{child.score}}</td>
                            </tr>
                        </template>
                    </template>
                </table>
            </template>
        </el-dialog>
    </div>
</template>
<script>
// import "videojs-flash";
// import "video.js/dist/lang/zh-CN";
// import SWF_URL from 'videojs-swf/dist/video-js.swf';
import videoAlertView from "@/components/common/videoAlertView";

export default {
            components: {
            videoAlertView
        },
    data() {
        return {
            ruleForm: {
                theme: '',
                ask: '',
                video: [],
                startTime: '',
                endTime: '',
                participant: [],
                standard: [],
                mode: '',
                range: []
            },
            multipleSelection: [],
            multipleSelection2: [],
            multipleSelection3: [],

            keyword: '',
            videoVisible: false,
            videoView: false,
            videoData: [],
            pageIndex: 1,
            pageSize: 10,
            totalSum: 0,
            videoList: [],

            roleList: [],
            roleVal: '',
            participantVisible: false,
            keyword2: '',
            pageIndex2: 1,
            pageSize2: 10,
            totalSum2: 0,
            participantData: [],
            participantList: [],

            subjectList: [],
            subject: '',
            standardVisible: false,
            keyword3: '',
            pageIndex3: 1,
            pageSize3: 10,
            totalSum3: 0,
            standardData: [],
            standardList: [],
            standardradio: '',
            standardradioID: '',

            viewCriteria: false,
            viewCriteriaList: {},
            rules: {
                theme: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                ask: [
                    { required: true, message: '请输入活动要求', trigger: 'change' },
                    { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
                ],
                video: [
                    { required: true, message: '请选择评课视频', trigger: 'change' }
                ],
                startTime: [
                    { required: true, message: '请选择开始时间', trigger: 'change' }
                ],
                endTime: [
                    { required: true, message: '请选择结束时间', trigger: 'change' }
                ],
                participant: [
                    { type: 'array', required: true, message: '请选择参与人', trigger: 'change' }
                ],
                standard: [
                    { required: true, message: '请选择评估标准', trigger: 'change' }
                ],
                mode: [
                    { required: true, message: '请选择写算分方式', trigger: 'change' }
                ],
                range: [
                    { required: true, message: '请选择评分明细公开范围', trigger: 'change' }
                ]
            },
            // playerOptions: { //播放器
            //     loop: false,
            //     height: "360",
            //     language: "zh-CN",
            //     sources: [{ type: "rtmp/mp4", src: "blala" }],
            //     techOrder: ["flash", "html5"],
            //     flash: {swf: SWF_URL },
            //     autoplay: true,
            //     controls: true,
            //     poster: "",
            //     controlBar: {
            //         timeDivider: true,
            //         durationDisplay: true,
            //         remainingTimeDisplay: false,
            //         fullscreenToggle: true //全屏按钮
            //     },
            //     flash: {swf: SWF_URL },
            // },
            showVideoPlayer: false,
            playParam: { play_url: "" },
            pickerOptions: {
                disabledDate:(time) => {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            isVideoView: false
        }
    },
    computed: {

    },
    watch: {
        'page_index':{
            handler(newVal) {
                this.standardData = this.standardData.slice((newVal - 1)*5, (newVal - 1)*5 + 5);
                this.standardradio = '';
            }
        },
    },
    methods: {
        // 单选框，选择点击的数据
        showStandardradio(row){
            this.standardradio = this.standardData.indexOf(row);
            this.standardradioID = row.id;
        },
        /*
            提交当前的数据
         */
        submitForm(formName) {


            this.$refs[formName].validate((valid) => {
                if (valid) {

                    let startTime = (new Date(this.ruleForm.startTime)).getTime();
                    let endTime = (new Date(this.ruleForm.endTime)).getTime();
                    let timestamp = (new Date()).getTime();

                    if (startTime > endTime) {
                       return this.$message.error('开始时间不能大于结束时间');

                    }else if (startTime < timestamp) {
                        return this.$message.error('开始时间不能小于当前时间');
                    }

                    let success = (res => {
                        this.$message.success(res.msg)
                        this.$router.push('/netteach')
                    });

                    let params = {
                        name: this.ruleForm.theme,
                        userid: this.$g.user_id,
                        standard_id: this.ruleForm.standard.join(','),
                        profile: this.ruleForm.ask,
                        start_time: this.ruleForm.startTime,
                        end_time: this.ruleForm.endTime,
                        score_type: this.ruleForm.mode,
                        public_flag: this.ruleForm.range.join(','),
                        video_string: this.ruleForm.video.join(','),
                        user_string: this.ruleForm.participant.join(',')
                    };

                    this.$ajax.post('api/network/eva_list', params, { func: { success: success } })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /*
            返回上一页
         */
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        /*
            @ 删除对应条件的数据
            @ video 评课视频
            @ participant 参与人
            @ standard 评估标准
         */
        handleClose(index, coordinate) {
            switch (coordinate) {
                case 'video':
                    this.videoList.splice(index, 1);
                    this.ruleForm.video.splice(index, 1)
                    break;
                case 'participant':
                    this.participantList.splice(index, 1);
                    this.ruleForm.participant.splice(index, 1)
                    break;
                case 'standard':
                    this.standardList.splice(index, 1);
                    this.ruleForm.standard.splice(index, 1)
                    break;
            }
        },
        /*
            选择视频
         */
        selectionChange(val) {
            this.multipleSelection = val;
        },
        /*
             评课视频
         */
        submitVideo() {

            if (this.multipleSelection.length === 0) {
                this.$message.error('请选择评课视频')
                return
            } else {
                let arr = [...this.multipleSelection, ...this.videoList]

                for (let i = 0; i < arr.length; i++) {
                    this.videoList.push(arr[i])
                }
                /*去重 */
                let hash = {};
                this.videoList = this.videoList.reduceRight((item, next) => {
                    hash[next.id] ? '' : hash[next.id] = true && item.push(next);
                    return item
                }, [])

                this.videoVisible = false
            }
        },
        /*
             请求视频列表数据
         */
        getVideoData() {
            this.videoVisible = true

            let success = (res => {
                this.videoData = res.data.data;
                this.totalSum = res.data.data_sum;
                this.pageIndex = parseInt(res.data.page_index)
            });

            this.$ajax({
                url: 'api/video/video_list',
                method: 'get',
                params: {
                    type: '-1',
                    status: 1,
                    page_index: this.pageIndex,
                    page_size: this.pageSize,
                    video_name: this.keyword,
                },
                func: { success: success }
            })
        },
        sizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getVideoData()
        },
        currentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.getVideoData()
        },
        /*
             视频预览
         */
        preview(url) {

            this.isVideoView = true;
            let that = this;
            this.showVideoPlayer = true;
            this.playParam.play_url = url;
            //  this.$refs.videoPlayer.player.src({ type: "rtmp/mp4", src: url });
            //     this.$refs.videoPlayer.player.play();
        },
        /*
             暂停视频预览
         */
        closeVideo() {
            this.isVideoView = false;
            this.showVideoPlayer = true;
            this.playParam.play_url = "00";
            // this.$refs.videoPlayer.player.pause();
            //  this.$refs.videoPlayer.player.src({ type: "rtmp/mp4", src: '00' });
        },
        /*
            弹窗--参与人
        */
        participantShow() {
            this.participantVisible = true;
            this.roleVal = '';
            this.keyword2 = ''
            this.getRoleList()
            this.getParticipant()

        },
        /*
            请求用户角色身份
        */
        getRoleList() {
            let success = (res => {
                this.roleList = res.data;
                this.roleList.unshift({'name': '全部','id': 0})
            });

            this.$ajax({
                url: 'api/role/get_all',
                method: 'get',
                params: { status: 1 },
                func: { success: success }
            })
        },
        /*
            请求参与人数据
        */
        getParticipant() {
            let success = (res => {
                this.participantData = res.data.data;
                this.totalSum2 = res.data.data_sum;
                this.pageIndex2 = parseInt(res.data.page_index)
            });
            this.$ajax({
                url: 'api/user/user',
                method: 'get',
                params: {
                    role_id: this.roleVal,
                    status: 1,
                    page: this.pageIndex2,
                    size: this.pageSize2,
                    data_type: 2,
                    name: this.keyword2
                },
                func: { success: success }
            })
        },
        sizeChange2(val) {

            this.pageSize2 = val;
            this.getParticipant()
        },
        currentChange2(val) {

            this.pageIndex2 = val;
            this.getParticipant()
        },
        /*
            选择视参与人
        */
        participantChange(val) {
            this.multipleSelection2 = val;
        },
        /*
             选择视参与人
         */
        submitParticipant() {

            if (this.multipleSelection2.length === 0) {
                this.$message.error('选择视参与人')
                return
            } else {
                let arr = [...this.multipleSelection2, ...this.participantList]

                for (let i = 0; i < arr.length; i++) {
                    this.participantList.push(arr[i])
                }
                /*去重 */
                let hash = {};
                this.participantList = this.participantList.reduceRight((item, next) => {
                    hash[next.id] ? '' : hash[next.id] = true && item.push(next);
                    return item
                }, [])

                this.participantVisible = false
            }
        },

        /*
            弹窗--评估标准
        */
        standardShow() {
            this.standardradio = '';
            this.standardradioID = '';
            this.standardVisible = true;
            this.subject = '';
            this.keyword3 = ''
            this.multipleSelection3 = []
            this.getSubjectList()
            this.getStandard()

        },
        /*
            请求科目
        */
        getSubjectList() {
            let success = (res => {
                this.subjectList = res.data;
                this.subjectList.unshift({ 'id': 0, 'name': '所有科目' })
            });

            this.$ajax({
                url: 'api/cate/subject',
                method: 'get',
                params: {},
                func: { success: success }
            })
        },
        /*
            请求评估标准数据
        */
        getStandard() {
            let success = (res => {
                this.standardData = res.data.data;
                this.totalSum3 = res.data.data_sum;
                this.pageIndex3 = parseInt(res.data.page_index)
            });
            this.$ajax({
                url: 'api/network/eva_standard',
                method: 'get',
                params: {
                    keyword: this.keyword3,
                    subject_id: this.subject,
                    page_index: this.pageIndex3,
                    page_size: this.pageSize3,
                    status: 1,
                    user_id: this.$g.user_id,

                    // data_type: 2
                },
                func: { success: success }
            })
        },
        sizeChange3(val) {

            this.pageSize3 = val;
            this.getStandard()
        },
        currentChange3(val) {

            this.pageIndex3 = val;
            this.getStandard()
        },
        /*
            选择评估标准
        */
        handleCurrentChange(val) {
           this.multipleSelection3 = []
           this.multipleSelection3.push(val);
           
        },
        /*
             选择视评估标准
         */
        submitStandard() {

            if (this.multipleSelection3.length === 0) {
                this.$message.error('选择视评估标准')
                return
            } else {
    
                this.standardList = this.multipleSelection3;
                this.standardVisible = false
            }
        },
        viewCriteriaShow(id) {

            this.viewCriteria = true;

            let success = (res => {
                this.viewCriteriaList = res.data
            });

            this.$ajax({
                url: 'api/network/standard_detail',
                method: 'get',
                params: { id: id },
                func: { success: success }
            })
        }

    }
}
</script>